import { LogoMark } from "./Logo";
import { Phone, Mail, MapPin } from "lucide-react";

export const Footer = () => (
  <footer data-testid="site-footer" className="relative border-t border-white/10 bg-[#0A0D14] overflow-hidden">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 pt-20 pb-10">
      <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-10 mb-16">
        <div>
          <div className="flex items-center gap-4 mb-6">
            <LogoMark className="w-14 h-14" />
            <span className="flex flex-col">
              <span className="font-display text-3xl font-extrabold tracking-[0.18em] text-white">DIMORA</span>
              <span className="text-[10px] uppercase tracking-[0.3em] text-amber-300/90 mt-1">
                Service pro & particulier
              </span>
            </span>
          </div>
          <p className="text-sm text-slate-400 max-w-sm leading-relaxed">
            Nettoyage & entretien à Gap et alentours : ménage de logements,
            entretien de locaux, vitres et fin de chantier. Le soin du détail,
            pour les pros comme pour les particuliers.
          </p>
        </div>
        <div className="flex gap-10 text-sm">
          <div className="flex flex-col gap-3">
            <span className="text-[10px] uppercase tracking-[0.22em] text-slate-500">Navigation</span>
            <a href="#services" data-testid="footer-services-link" className="text-slate-300 hover:text-amber-300 transition-colors">Services</a>
            <a href="#galerie" data-testid="footer-gallery-link" className="text-slate-300 hover:text-amber-300 transition-colors">Galerie</a>
            <a href="#devis" data-testid="footer-booking-link" className="text-slate-300 hover:text-amber-300 transition-colors">Devis en ligne</a>
          </div>
          <div className="flex flex-col gap-3">
            <span className="text-[10px] uppercase tracking-[0.22em] text-slate-500">Contact</span>
            <a href="tel:+33618907435" data-testid="footer-phone-link" className="flex items-center gap-2 text-slate-300 hover:text-amber-300 transition-colors">
              <Phone className="w-3.5 h-3.5 text-amber-400" /> 06 18 90 74 35
            </a>
            <a href="mailto:d.contactdimora@gmail.com" data-testid="footer-email-link" className="flex items-center gap-2 text-slate-300 hover:text-amber-300 transition-colors">
              <Mail className="w-3.5 h-3.5 text-amber-400" /> d.contactdimora@gmail.com
            </a>
            <span className="flex items-center gap-2 text-slate-400">
              <MapPin className="w-3.5 h-3.5 text-amber-400" /> Gap et alentours — 04 · 05
            </span>
          </div>
        </div>
      </div>

      <p className="font-display font-extrabold uppercase tracking-[0.1em] leading-none text-stroke select-none text-[16vw] lg:text-[10rem] whitespace-nowrap -mx-2">
        Dimora
      </p>

      <div className="mt-10 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-5">
        <p className="text-xs text-slate-500">© 2026 DIMORA — Nettoyage & Entretien — Tous droits réservés</p>
        <p className="text-[10px] uppercase tracking-[0.18em] text-slate-400">
          Hautes-Alpes (05) · Alpes-de-Haute-Provence (04)
        </p>
      </div>
    </div>
  </footer>
);
